import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, CircularProgress, Stack, Tab, Typography, styled, Card } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useSnackbar } from 'notistack';

// Tabs
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import { LoadingButton } from '@mui/lab';
import LoadingScreen from '../../components/LoadingScreen';

import Iconify from '../../components/Iconify';
import { useDispatch, useSelector } from '../../redux/store';
import { openLoginSignup, setIsPopupOpened } from '../../redux/slices/authPages';
import { setActiveTab } from '../../redux/slices/game';

import useAuth from '../../hooks/useAuth';
import { fCurrency, fNumberCommaSeparated } from '../../utils/formatNumber';

import Page from '../../components/Page';
import Image from '../../components/Image';
import conObj from '../../utils/connection-assistant';
import BannerCarousel from './BannerCarousel';
import { getPromotions } from '../../redux/slices/lookup';
import CustomModal from '../../components/CustomModal';
import { calculateFontSize, isHTML, sanitizeHtml } from '../../utils/formatString';
import useResponsive from '../../hooks/useResponsive';
import useLocales from '../../hooks/useLocales';
import palette from '../../theme/palette';
import { HEADER, NAVBAR } from '../../config';
import GameContainer from './GameContainer';
import useStickyDetect from '../../hooks/useStickyDetect';
import { closeLoadingScreen, openLoadingScreen } from '../../redux/slices/settings';

import PopularActiveIcon from '../../assets/menu/popular-active.png';
import PopularInactiveIcon from '../../assets/menu/popular-inactive.png';
import HotGamesCarousel from './HotGamesCarousel';

import usePopularLoadOnScroll from './usePopularLoadOnScroll';
import PopupBanner from '../../layouts/dashboard/PopupBanner';

const MemberNavBg = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  // flexFlow: 'column',
  width: '100%',
  height: '1.15rem',
  // height: 'auto',
  paddingLeft: '.12rem',
  borderRadius: '.2rem',
  boxShadow: '0 0 .1rem rgba(0,0,0,.12)',
  backgroundColor: '#fff',
  position: 'relative',
  padding: '.12rem',
}));

const LeftNavigationLogin = styled(Box)(({ theme }) => ({
  // width: '2.8rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  overflow: 'hidden',
}));

const UserInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '.06rem',
}));

const Username = styled(Typography)(({ theme }) => ({
  whiteSpace: 'nowrap',
  // overflow: 'hidden',
  // textOverflow: 'ellipsis',
  fontSize: '.23rem',
  lineHeight: '1.1',
  color: '#181644',
}));

const MemberBalance = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));

const RightNavigation = styled(Box)(({ theme }) => ({
  // width: '4.52rem',
  paddingLeft: '0.2rem',
  flex: 1,
  display: 'flex',
  justifyContent: 'end',
  paddingRight: '.12rem',
  marginTop: '.12rem',
}));

const RightNavList = ({ children }) => <li style={{ flex: '1 1 0%', textAlign: 'center' }}>{children}</li>;

const RightNavListIcon = styled(Image)(({ theme }) => ({
  position: 'relative',
  // width: '0.63rem',
  // height: '0.63rem',
  margin: '0 auto',
  cursor: 'pointer',
  [theme.breakpoints.down('sm')]: {
    width: '6.5vw',
    height: '6.5vw',
  },
  [theme.breakpoints.up('sm')]: {
    width: '0.63rem',
    height: '0.63rem',
  },
}));

const RightNavListText = styled(Typography)(({ theme }) => ({
  lineHeight: 1,
  color: '#2b3990',
  fontSize: '.2rem',
  textAlign: 'center',
  whiteSpace: 'nowrap',
  [theme.breakpoints.down('sm')]: {
    fontSize: '2vw',
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '.2rem',
  },
}));

const depositBanners = {
  imgDeposit: require('../../assets/home/deposit_banners/fast_deposit_n_payout-en.png'),
  imgTng: require('../../assets/home/deposit_banners/tngpin-en.png'),
};

// const depositBanners = [
//   {
//     lang: 'en',
//     imgDeposit: require('../../assets/home/deposit_banners/fast_deposit_n_payout-en.png'),
//     imgTng: require('../../assets/home/deposit_banners/tngpin-en.png'),
//   },
//   {
//     lang: 'my',
//     imgDeposit: require('../../assets/home/deposit_banners/fast_deposit_n_payout-my.png'),
//     imgTng: require('../../assets/home/deposit_banners/tngpin-my.png'),
//   },
//   {
//     lang: 'id',
//     imgDeposit: require('../../assets/home/deposit_banners/fast_deposit_n_payout-id.png'),
//     imgTng: require('../../assets/home/deposit_banners/tngpin-id.png'),
//   },
// ];

const Home = () => {
  const navigate = useNavigate();

  const { translate, currentLang } = useLocales();

  const isAuthenticated = localStorage.getItem('accessToken');

  const { userProfile } = useAuth();

  const {
    // promotions,
    angPauPromos,
    siteSettings,
    gameCategsAndCompanies,
    memberBalance,
  } = useSelector((x) => x.lookup);

  const { activeTab } = useSelector((x) => x.game);

  const { isPopupOpened } = useSelector((x) => x.authPages);

  const dispatch = useDispatch();

  const theme = useTheme();

  const { enqueueSnackbar } = useSnackbar();

  const [openAlert, setOpenAlert] = useState(true);

  const [allGames, setAllGames] = useState([]);

  const [openPromotion, setOpenPromotion] = useState(null);

  const [isLoadingGames, setIsLoadingGames] = useState(false);

  const [isLoadingMoreKey, setIsLoadingMoreKey] = useState(-1);

  const isDesktop = useResponsive('up', 'lg');

  const gamesRef = useRef(null);

  const tabsRef = useRef(null);

  const [sortBy, setSortBy] = useState('');

  const [pages, setPages] = useState([]);

  // const [popularGames, setPopularGames] = useState({
  //   data: [],
  //   page: 1,
  // });

  // const [popularGamesTotal, setPopularGamesTotal] = useState(0);

  // const [isLoadingPopGames, setIsLoadingPopGames] = useState(false);

  const { targetRef: stickyRef, isSticky } = useStickyDetect(HEADER.MOBILE_HEIGHT);

  const { popularGames, isLoadingPopGames, hasMore, page, setPage } = usePopularLoadOnScroll();

  const observer = useRef();

  const lastPopGameElementRef = useCallback(
    (node) => {
      if (isLoadingPopGames) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prevState) => prevState + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoadingPopGames, hasMore]
  );

  const handleChange = (event, newValue) => {
    dispatch(setActiveTab(newValue));
    const scrollEl = document.getElementById(newValue);
    if (scrollEl) scrollEl.scrollIntoView({ behavior: 'smooth' });
  };

  const settings = {
    dots: false,
    arrows: false,
    autoplay: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    rtl: Boolean(theme.direction === 'rtl'),
    responsive: [
      {
        breakpoint: theme.breakpoints.values.lg,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: theme.breakpoints.values.md,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: theme.breakpoints.values.sm,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  useEffect(() => {
    const promises = [getPages(), getPromotions()];
    dispatch(openLoadingScreen());
    Promise.all(promises).finally(() => dispatch(closeLoadingScreen()));
    dispatch(setIsPopupOpened(isPopupOpened + 1));
  }, []);

  useEffect(() => {
    const scrollEl = document.getElementById(activeTab);
    if (scrollEl) {
      scrollEl.scrollIntoView({ behavior: 'smooth' });
    }
  }, [activeTab]);

  useEffect(() => {
    handleResetLoadMore();
  }, [activeTab]);

  const handleLoadMore = (key) => {
    const indexToUpdate = allGames.findIndex((item) => item.key === key);
    const gamesByKey = allGames.find((item) => item.key === key);

    setIsLoadingMoreKey(key);

    if (indexToUpdate === -1) {
      // Item not found, handle this case as needed
      return;
    }

    // check if has to load more
    // check count
    // check showCount
    // increment by 12
    const _gamesByTab = allGames.find((f) => f.key === key);
    const count = _gamesByTab.page.total_data;
    const showCount = _gamesByTab.showCount;
    const currentPage = _gamesByTab.currentPage;

    if (parseInt(count, 10) > showCount) {
      conObj
        .post(`games/all.json?key=${key}&limit=12&page=${currentPage + 1}${sortBy ? `&sort=${sortBy}` : ''}`)
        .then((res) => {
          if (res.status === 200) {
            const updatedData = [
              ...allGames.slice(0, indexToUpdate), // Elements before the updated item
              {
                ...res.data?.data?.data[0],
                games: [...gamesByKey?.games, ...res.data?.data?.data[0]?.games],
                showCount: showCount + res.data?.data?.data[0]?.games.length,
                currentPage: currentPage + 1,
              }, // The updated item
              ...allGames.slice(indexToUpdate + 1), // Elements after the updated item
            ];

            setAllGames(updatedData);
          }
        })
        .catch((err) => {
          console.log(`Server Error: ${err.message}`);
        })
        .finally(() => setIsLoadingMoreKey(-1));
    } else setIsLoadingMoreKey(-1);
  };

  const handleResetLoadMore = () => {
    console.log(`handlereset = ${allGames.filter((f) => f.showCount > 12).length}`);
    if (allGames.filter((f) => f.showCount > 12).length > 0) {
      console.log('enter');
      setAllGames([...allGames.map((item) => ({ ...item, showCount: 12, currentPage: 1 }))]);
    }
  };

  const getCategoryIcon = (categoryName, isActive) => {
    let nav = '';
    if (categoryName === 'slots')
      nav = {
        src: isActive ? require('../../assets/menu/slots-active.png') : require('../../assets/menu/slots-inactive.png'),
      };

    if (categoryName === 'live-casino')
      nav = {
        src: isActive
          ? require('../../assets/menu/casino-active.png')
          : require('../../assets/menu/casino-inactive.png'),
      };

    if (categoryName === 'fishing')
      nav = {
        src: isActive
          ? require('../../assets/menu/fishing-active.png')
          : require('../../assets/menu/fishing-inactive.png'),
      };

    if (categoryName === 'card-game')
      nav = {
        src: isActive ? require('../../assets/menu/poker-active.png') : require('../../assets/menu/poker-inactive.png'),
      };

    if (categoryName === 'sports')
      nav = {
        src: isActive
          ? require('../../assets/menu/sports-active.png')
          : require('../../assets/menu/sports-inactive.png'),
      };

    if (categoryName === 'e-sports')
      nav = {
        src: isActive
          ? require('../../assets/menu/e-sports-active.png')
          : require('../../assets/menu/e-sports-inactive.png'),
      };

    if (categoryName === 'instant-game') nav = { icon: 'ph:lightning-fill' };

    return nav;
  };

  const getPages = () =>
    conObj
      .post(`/pages.json`)
      .then((res) => {
        if (res.status === 200) {
          if (res.data?.data?.data?.length > 0) {
            setPages(res.data?.data?.data?.map((item) => ({ pageKey: item?.page_key, title: item?.title })));
          }
        }
      })
      .catch((err) => {
        console.log(`Error: ${err?.message}`);
      });
  return (
    <Page title="Home" sx={{ position: 'relative' }}>
      <Box sx={{ width: '100%', px: { sm: 2, xs: 0 } }}>
        {/* Home Banner */}
        <BannerCarousel />

        {siteSettings?.announcement_text?.WalkPromotion?.content && (
          <Stack
            direction="row"
            alignItems={'center'}
            sx={{
              m: '0 0.5rem',
              // backgroundColor: 'transparent',
              cursor: siteSettings?.announcement_text?.WalkPromotion?.url ? 'pointer' : 'none',
            }}
            onClick={() => {
              if (siteSettings?.announcement_text?.WalkPromotion?.url) {
                window.open(siteSettings?.announcement_text?.WalkPromotion?.url, '_blank');
              }
            }}
          >
            <Image
              src={require('../../assets/home/speaker-icon.png')}
              sx={{ width: '.38rem', height: '.38rem', mr: 1, minWidth: '.38rem', minHeight: '.38rem' }}
            />
            {/* <Iconify
              icon={'pepicons-pencil:megaphone'}
              color={palette.home.announcement.color}
              width={25}
              height={25}
              sx={{ mr: 1, minWidth: '25px', minHeight: '25px' }}
            /> */}
            <Box className="marquee" sx={{ width: '100%' }}>
              <Typography sx={{ color: palette.home.announcement.color, fontWeight: 400, fontSize: '.25rem' }}>
                {siteSettings?.announcement_text?.WalkPromotion?.content}
              </Typography>
            </Box>
          </Stack>
        )}
      </Box>

      <Box sx={{ p: { md: '0 .32rem', sm: '0 .1rem', xs: '0 .1rem' } }}>
        <MemberNavBg>
          <LeftNavigationLogin
            className={!isAuthenticated && 'nav_left_nologin'}
            onClick={() => (!isAuthenticated ? navigate('/auth/login') : {})}
          >
            {isAuthenticated ? (
              <>
                <UserInfo>
                  <Username sx={{ whiteSpace: 'nowrap' }}>{userProfile?.username}</Username>
                  {/* <Iconify
                    icon={'mdi:heart'}
                    sx={{
                      width: '.4rem',
                      height: '.4rem',
                      flexShrink: 0,
                      marginLeft: '0.03rem',
                      color: 'gold',
                    }}
                  /> */}
                </UserInfo>
                <MemberBalance>
                  <Box
                    sx={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      fontWeight: 600,
                      fontSize: '.27rem',
                      lineHeight: '1.1',
                      color: '#181644',
                    }}
                  >
                    <span>{`${memberBalance?.currencyCode} ${
                      memberBalance?.displayBalance ? fCurrency(memberBalance?.displayBalance) : 0
                    }`}</span>
                  </Box>
                </MemberBalance>
              </>
            ) : (
              <span
                style={{
                  fontSize: '.24rem',
                  fontWeight: 600,
                  textAlign: 'center',
                  cursor: 'pointer',
                  padding: '0 5px',
                }}
              >
                {translate('login')} / {translate('register')}
              </span>
            )}
          </LeftNavigationLogin>
          <RightNavigation>
            <Stack direction={'row'} spacing={{ xs: '.1rem', sm: 1, md: 2, lg: 3 }}>
              {/* {angPauPromos?.data?.length && ( */}
              {/* <Stack
                direction="column"
                // onClick={() => navigate(isAuthenticated ? '/transaction/deposit' : '/auth/login')}
                onClick={() => navigate('/angpau')}
              >
                <RightNavListIcon src={require('../../assets/angpau/angpau_logo.png')} className="pulse-shadow" />
                <RightNavListText>{translate('Angpau')}</RightNavListText>
              </Stack> */}
              {/* )} */}

              <Stack
                direction="column"
                // onClick={() => navigate(isAuthenticated ? '/transaction/deposit' : '/auth/login')}
                onClick={() => navigate('/luckydraw')}
              >
                <RightNavListIcon src={require('../../assets/home/lucky_draw.png')} />
                <RightNavListText>{translate('lucky_draw')}</RightNavListText>
              </Stack>

              {/* <Stack
                direction="column"
                onClick={() => navigate(isAuthenticated ? '/transaction/deposit' : '/auth/login')}
              >
                <RightNavListIcon src={require('../../assets/home/tngpin.png')} />
                <RightNavListText>TNG Pin</RightNavListText>
              </Stack> */}

              {/* <Stack direction="column">
                <RightNavListIcon
                  src={require('../../assets/home/btn_more.png')}
                  sx={{
                    width: { xs: '6vw !important', sm: '5.5vw !important', md: '0.55rem !important' },
                    height: 'auto !important',
                  }}
                />
                <RightNavListText sx={{ display: 'block', mt: 'auto' }}>{translate('more')}</RightNavListText>
              </Stack> */}

              <Stack direction="column" onClick={() => navigate(isAuthenticated ? '/referral' : '/auth/login')}>
                <RightNavListIcon src={require('../../assets/home/btn_invite.png')} />
                <RightNavListText sx={{ display: 'block', mt: 'auto' }}>{translate('Earn')}</RightNavListText>
              </Stack>

              <Stack
                direction="column"
                onClick={() => navigate(isAuthenticated ? '/transaction/deposit' : '/auth/login')}
              >
                <RightNavListIcon src={require('../../assets/home/btn_deposit.png')} />
                <RightNavListText>{translate('deposit')}</RightNavListText>
              </Stack>

              <Stack
                direction="column"
                onClick={() => navigate(isAuthenticated ? '/transaction/withdraw' : '/auth/login')}
              >
                <RightNavListIcon src={require('../../assets/home/btn_withdraw.png')} />
                <RightNavListText>{translate('withdraw')}</RightNavListText>
              </Stack>
            </Stack>
          </RightNavigation>
        </MemberNavBg>
      </Box>

      <Stack
        direction="row"
        sx={{ mt: 1, justifyContent: 'center', p: { md: '0 .32rem', sm: '0 .1rem', xs: '0 .1rem' } }}
        spacing={1}
      >
        <Image
          ratio={'calc(50% / 213 * 137)'}
          isNotFull={true}
          alt="Fast Deposit Banner"
          src={depositBanners?.imgDeposit}
          sx={{
            flex: 1,
            maxWidth: '50%',
            img: {
              objectFit: 'contain',
            },
            borderRadius: 1.5,
          }}
        />
        <Image
          ratio={'calc(50% / 213 * 137)'}
          isNotFull={true}
          alt="Tng Pin"
          src={depositBanners?.imgTng}
          sx={{
            flex: 1,
            maxWidth: '50%',
            img: {
              objectFit: 'contain',
            },
            borderRadius: 1.5,
          }}
        />
      </Stack>

      <Container
        maxWidth="lg"
        sx={{
          px: { md: '.38rem', sm: '.1rem', xs: '.1rem' },
        }}
      >
        {/* Alert */}
        {/* {openAlert && siteSettings?.announcement_text?.WalkPromotion?.content ? (
          <Box sx={{ backgroundColor: '#38db87', p: 2, position: 'relative', mb: 1 }}>
            <Stack direction="row" alignItems={'center'}>
              <Typography sx={{ fontSize: '12px', fontWeight: 700, color: 'black', flexGrow: 1 }}>
                {siteSettings?.announcement_text?.WalkPromotion?.content}
              </Typography>
              <button
                type="button"
                style={{
                  backgroundColor: '#d10b43',
                  border: 'none',
                  color: 'white',
                  padding: '3px 12px',
                  fontWeight: 700,
                  lineHeight: '18.2px',
                  fontSize: '13px',
                  borderRadius: '10px',
                  margin: '0 10px 0 20px',
                }}
              >
                Details
              </button>
              <Iconify
                icon={'ep:close'}
                width={24}
                height={24}
                sx={{ cursor: 'pointer' }}
                onClick={() => setOpenAlert(false)}
              />
            </Stack>
          </Box>
        ) : (
          <></>
        )} */}

        <Box ref={gamesRef} sx={{ mt: 1 }} />

        {/* Promotions */}
        {/* <PromotionCarousel /> */}

        <Card
          sx={{ backgroundColor: 'rgba(255, 255, 255, 0.7)', boxShadow: '0px 2px 9.3px 0px #00000073', p: '0.2rem' }}
        >
          <TabContext value={activeTab}>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'stretch',
                flexDirection: 'row',
                transition: 'all .5s',
                overflow: 'hidden',
              }}
            >
              <Box sx={{ width: '2rem', overflow: 'hidden' }}>
                <Box
                  sx={{
                    mb: 4,
                    width: '100%',
                    // position: 'relative',

                    // position: { xs: 'sticky', sm: 'sticky', md: 'sticky', lg: 'unset', xl: 'unset' },
                    top: `${HEADER.MOBILE_HEIGHT}px`,
                    borderTopLeftRadius: 1,
                    borderTopRightRadius: 1,
                    zIndex: 2,
                  }}
                  ref={stickyRef}
                  // ref={tabsRef}
                >
                  <Stack
                    spacing={{ lg: 1, md: 1, sm: 1, xs: 2 }}
                    direction={{ xl: 'row', lg: 'row', md: 'row', sm: 'row', xs: 'column' }}
                    sx={{ borderRadius: '15px' }}
                    alignItems={{ sm: 'end', xs: 'unset' }}
                  >
                    <Box
                      sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <TabList
                        onChange={handleChange}
                        aria-label="Game Category Tabs"
                        TabIndicatorProps={{
                          style: { backgroundColor: 'transparent' },
                        }}
                        sx={{
                          minHeight: 'unset',
                          color: 'white',
                        }}
                        centered={isDesktop}
                        variant="standard"
                        scrollButtons="auto"
                        orientation="vertical"
                        allowScrollButtonsMobile
                        TabScrollButtonProps={{
                          sx: {
                            width: '30px',
                            borderRadius: 0,
                          },
                        }}
                      >
                        <Tab
                          label={
                            <Box
                              sx={{
                                background:
                                  activeTab === 'Popular'
                                    ? `url(${require('../../assets/menu/menu-bg.png')}) no-repeat 50% / 100% 100%`
                                    : 'transparent',
                                position: 'relative',
                                display: 'flex',
                                alignItems: 'center',
                                width: '1.89rem',
                                height: '0.89rem',
                                pl: '0.23rem',
                              }}
                            >
                              <Stack direction="row" alignItems="center" sx={{ overflow: 'hidden' }}>
                                <Image
                                  src={activeTab === 'Popular' ? PopularActiveIcon : PopularInactiveIcon}
                                  alt="Popular"
                                  sx={{
                                    width: '0.47rem',
                                    height: '0.47rem',
                                    cursor: 'pointer',
                                    mr: '0.1rem',
                                    flexShrink: 0,
                                  }}
                                />
                                <Typography
                                  sx={{
                                    color:
                                      activeTab === 'Popular'
                                        ? palette.home.tab.textActive
                                        : palette.home.tab.textInactive,
                                    fontSize: '.24rem',
                                    fontWeight: 400,
                                    whiteSpace: 'nowrap',
                                    borderTopLeftRadius: '6px',
                                    borderTopRightRadius: '6px',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                  }}
                                >
                                  {translate('popular')}
                                </Typography>
                              </Stack>
                            </Box>
                          }
                          value="Popular"
                          sx={{
                            minHeight: 'unset',
                            marginRight: '10px !important',
                            fontSize: '14px',
                            justifyContent: 'end',
                          }}
                        />
                        {gameCategsAndCompanies.map((item, index) => {
                          const iconVal = getCategoryIcon(item.slug, activeTab === item.slug);
                          return (
                            <Tab
                              key={index}
                              label={
                                <Box
                                  sx={{
                                    background:
                                      activeTab === item.slug
                                        ? `url(${require('../../assets/menu/menu-bg.png')}) no-repeat 50% / 100% 100%`
                                        : 'transparent',
                                    position: 'relative',
                                    display: 'flex',
                                    alignItems: 'center',
                                    width: '1.89rem',
                                    height: '0.89rem',
                                    pl: '0.23rem',
                                  }}
                                >
                                  <Stack direction="row" alignItems="center" sx={{ overflow: 'hidden' }}>
                                    {iconVal?.src ? (
                                      <Image
                                        src={iconVal.src}
                                        alt="All Games"
                                        sx={{
                                          width: '0.47rem',
                                          height: '0.47rem',
                                          cursor: 'pointer',
                                          mr: '0.1rem',
                                          flexShrink: 0,
                                        }}
                                      />
                                    ) : (
                                      <Iconify
                                        icon={iconVal.icon}
                                        sx={{
                                          width: '25px',
                                          height: 'auto',
                                          mr: '4px',
                                          cursor: 'pointer',
                                          color: activeTab === item.slug ? 'rgb(32, 37, 101)' : 'rgb(173, 185, 212)',
                                        }}
                                      />
                                    )}
                                    <Typography
                                      sx={{
                                        color:
                                          activeTab === item?.slug
                                            ? palette.home.tab.textActive
                                            : palette.home.tab.textInactive,

                                        fontSize: '.24rem',
                                        fontWeight: 400,
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                      }}
                                    >
                                      {item.name}
                                    </Typography>
                                  </Stack>
                                </Box>
                              }
                              value={item.slug}
                              sx={{
                                minHeight: 'unset',
                                marginRight: '10px !important',
                                fontSize: '14px',
                                minWidth: { xl: '90px', lg: '90px', md: '90px', sm: '90px', xs: 'unset' },
                                justifyContent: 'end',
                              }}
                            />
                          );
                        })}
                      </TabList>
                    </Box>
                  </Stack>
                </Box>
              </Box>
              <Box sx={{ height: '450px', position: 'relative', width: 'calc(100% - 2rem)', overflow: 'hidden' }}>
                <Box sx={{ height: '100%', overflowY: 'scroll' }}>
                  <TabPanel key="Popular" value={'Popular'} sx={{ width: '100%', p: '.05rem .32rem 0 .1rem' }}>
                    {popularGames?.length > 0 && (
                      <Box id={'Popular'} sx={{ scrollMarginTop: HEADER.MOBILE_HEIGHT }}>
                        <Box
                          sx={{
                            position: 'relative',
                            display: 'grid',
                            gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
                            columnGap: '0.36rem',
                            rowGap: '0.15rem',
                          }}
                        >
                          {popularGames?.map((g, gIndex) => (
                            <Box
                              ref={popularGames?.length === gIndex + 1 ? lastPopGameElementRef : null}
                              key={gIndex}
                              sx={{ position: 'relative', maxWidth: '100%', overflow: 'hidden' }}
                            >
                              <GameContainer item={g} titleSx={{ fontSize: calculateFontSize(g?.name, 14, 18) }} />
                            </Box>
                          ))}
                        </Box>
                        {isLoadingPopGames && (
                          <CircularProgress sx={{ color: '#2b3990', m: '.5rem auto', display: 'block' }} size={30} />
                        )}
                        {/* {parseFloat(popularGamesTotal) > popularGames?.data.length && (
                        <Box sx={{ mt: '.2rem', mb: '.5rem' }}>
                          <LoadingButton
                            sx={{
                              background: '#fff',
                              color: '#181644',
                              fontSize: '.20rem',
                              fontWeight: 500,
                              marginLeft: 'auto',
                              marginRight: 'auto',
                              display: 'flex',
                              '&:hover': {
                                background: '#fff !important',
                              },
                            }}
                            variant="contained"
                            color="inherit"
                            loading={isLoadingPopGames}
                            disabled={isLoadingPopGames}
                            onClick={() => getPopularGames()}
                          >
                            {translate('more_x_of_y', { x: popularGames?.data.length, y: popularGamesTotal })}
                          </LoadingButton>
                        </Box>
                      )} */}
                      </Box>
                    )}
                  </TabPanel>

                  {gameCategsAndCompanies.map((item, index) => {
                    const iconVal = getCategoryIcon(item.slug);
                    return (
                      <TabPanel
                        key={item.slug}
                        value={item.slug}
                        sx={{ scrollMarginTop: HEADER.MOBILE_HEIGHT, p: '.05rem .32rem 0 .1rem' }}
                      >
                        <Box
                          sx={{
                            position: 'relative',
                            display: 'grid',
                            gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
                            columnGap: '0.12rem',
                            rowGap: '0.14rem',
                          }}
                        >
                          {item.companies.map((g, gIndex) => (
                            <Box key={gIndex} sx={{ position: 'relative', maxWidth: '100%', overflow: 'hidden' }}>
                              <GameContainer
                                item={g}
                                companySlug={item?.slug}
                                titleSx={{ fontSize: calculateFontSize(g?.name, 14, 18) }}
                              />
                            </Box>
                          ))}

                          {/* <Grid container spacing={2}>
                        {item.companies.map((g, gIndex) => (
                          <Grid key={gIndex} item xl={2} lg={2} md={2} sm={4} xs={4}>
                            <GameContainer
                              item={g}
                              companySlug={item?.slug}
                              titleSx={{ fontSize: calculateFontSize(g?.name, 14, 18) }}
                            />
                          </Grid>
                        ))}
                      </Grid> */}
                        </Box>
                      </TabPanel>
                    );
                  })}
                </Box>
              </Box>
            </Box>
          </TabContext>
        </Card>

        {/* <HotGamesCarousel /> */}

        {/* <Typography
          onClick={() => navigate('/tnc')}
          sx={{
            cursor: 'pointer',
            fontSize: '.2rem',
            color: 'blue',
            display: 'block',
            mx: 'auto',
            p: '.3rem',
            background: 'rgb(0, 0, 255, .1)',
            textAlign: 'center',
            fontWeight: 600,
          }}
        >
          {translate('terms_n_conditions')}
        </Typography> */}

        {/* <Services /> */}
      </Container>

      <CustomModal
        open={!!openPromotion}
        onClose={() => setOpenPromotion(null)}
        children={
          <Stack spacing={4} sx={{ p: 2 }}>
            <Box sx={{ width: '100%', textAlign: 'center' }}>
              <Typography className="gold-text" variant="h4" fontWeight={900}>
                {openPromotion?.title}
              </Typography>
            </Box>

            <Box sx={{ width: '100%' }}>
              {openPromotion?.description && isHTML(openPromotion?.description) ? (
                <Box
                  sx={{
                    '& ol, ul': { listStylePosition: 'inside', overflow: 'hidden' },
                    '& li p': { display: 'inline' },
                  }}
                  dangerouslySetInnerHTML={sanitizeHtml(openPromotion?.description)}
                />
              ) : (
                <Typography>{openPromotion?.description || ''}</Typography>
              )}
            </Box>
          </Stack>
        }
      />

      {pages?.length > 0 && (
        <Box sx={{ width: '100%', px: 3, py: 4, backgroundColor: '#e7e8ffc4' }}>
          <Image
            src={require('../../assets/brand-logo.png')}
            sx={{
              width: '1.2rem',
              height: '1.2rem',
              img: {
                objectFit: 'contain',
              },
            }}
          />
          <Stack direction={'row'} spacing={1} sx={{ width: '100%', mt: 1 }}>
            {pages.map((item, index) => (
              <Typography
                key={index}
                onClick={() => navigate(`/page/${item?.pageKey}`)}
                variant="caption"
                sx={{
                  cursor: 'pointer',
                  fontSize: '12px',
                  color: '#00046A',
                  display: 'block',
                  fontWeight: 600,
                  width: 'auto',
                  textDecoration: 'underline',
                }}
              >
                {item?.title}
              </Typography>
            ))}
          </Stack>
        </Box>
      )}

      {siteSettings?.popups?.length > 0 && isPopupOpened <= siteSettings?.popups?.length
        ? [...siteSettings?.popups].reverse().map((item, index) => <PopupBanner key={index} popupBanner={item} />)
        : ''}
    </Page>
  );
};

export default Home;
